/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_No_DataInputs */

const vi_order_no_data = /** @type {(inputs: Order_No_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có đơn hàng nào`)
};

/**

* @param {Order_No_DataInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_no_data = /** @type {((inputs?: Order_No_DataInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_No_DataInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_no_data(inputs)
});